// src/pages/TeamPage.tsx
import React, { useState, useEffect } from 'react';
import { UserList } from '../components/team/UserList';
import { SearchFilters } from '../components/team/SearchFilters';
import { AddUserModal } from '../components/team/AddUserModal';
import { useTeamStore } from '../stores/teamStore';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { ErrorMessage } from '../components/common/ErrorMessage';
import { Plus } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const TeamPage = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const { loading, error, fetchUsers, fetchRoles, users, roles } = useTeamStore();
  const { translations } = useLanguage();

  // Initialize both users and roles data when component mounts
  useEffect(() => {
    const initializeData = async () => {
      console.log('TeamPage - Initializing data');
      try {
        // Fetch both users and roles data
        await Promise.all([
          fetchUsers(),
          fetchRoles()
        ]);
        console.log('TeamPage - Data initialized successfully');
      } catch (err) {
        console.error('TeamPage - Error initializing data:', err);
      }
    };

    // Only fetch if we don't have data yet
    if (!users || Object.keys(users).length === 0 || !roles || Object.keys(roles).length === 0) {
      initializeData();
    }
  }, [fetchUsers, fetchRoles, users, roles]);

  // Show loading only if we have no data yet
  if (loading && (!users || Object.keys(users).length === 0)) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">
          {translations?.team?.title || 'Team'}
        </h1>
        <button
          onClick={() => setIsAddModalOpen(true)}
          className="bg-primary-500 text-white px-4 py-2 rounded-lg hover:bg-primary-600 
                   transition-colors flex items-center gap-2"
        >
          <Plus size={20} />
          <span>{translations?.team?.addMember || 'Add Member'}</span>
        </button>
      </div>

      <SearchFilters />
      <UserList />
      <AddUserModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} />
    </div>
  );
};